import React from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';

import { connect } from 'react-redux';
import { getLoaders } from 'selectors';

import { resetErrorMessage } from '../../../actions/internal';
import {
  fetchProgramContentEntries,
  updateProgramContentMeta,
} from './actions';
import { showNewMessageModal, sendMessage, sendMessageGroups } from '../../../actions/communication';
import { createModalConfig } from '../../../utils/communication/modalConfigUtils';
import {
  selectProgramContentLibraryEntries,
  selectProgramContentLibraryMeta,
} from './selectors';
import { isChatEnabled } from '../../../utils/authScopes';
import { getParamsFromQuery } from '../../../utils/query';

import TopNavBar from '../../../containers/nav/TopNavBar';
import SubNavBar from '../../../containers/nav/SubNavBar';
import LibrarySubNav from '../../../components/nav/LibrarySubNav';

import ProgramContentLibraryFilters from './ProgramContentLibraryFilters';
import ProgramContentEntriesTable from './ProgramContentEntriesTable';

class ProgramContentLibraryPage extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    resetErrorMessage: PropTypes.func.isRequired,
    fetchProgramContentEntries: PropTypes.func.isRequired,
    programContentEntries: PropTypes.arrayOf(PropTypes.object).isRequired,
    meta: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    updateProgramContentMeta: PropTypes.func.isRequired,
    showNewMessageModal: PropTypes.func.isRequired,
    sendMessage: PropTypes.func.isRequired,
    sendMessageGroups: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleProgramContentEntrySend = this.handleProgramContentEntrySend.bind(this);
  }

  componentDidMount() {
    this.props.resetErrorMessage();
    this.fetchInitialProgramContentEntries();
  }

  fetchInitialProgramContentEntries() {
    this.props.updateProgramContentMeta(this.initialParams());
  }

  initialParams() {
    const queryString = this.props.history.location.search;

    if (queryString.length > 0) {
      return getParamsFromQuery(queryString);
    }

    return this.props.meta;
  }

  render() {
    const { programContentEntries, meta, isLoading } = this.props;

    return (
      <DocumentTitle title='Sparkler - Tips Library'>
        <div>
          <TopNavBar />
          <SubNavBar />
          <LibrarySubNav />
          <div className="row">
            <div className="column">
              <ProgramContentLibraryFilters isLoading={isLoading} />
              <ProgramContentEntriesTable
                programContentEntries={programContentEntries}
                meta={meta}
                isLoading={isLoading}
                onPageChange={this.handlePageChange}
                allowSend={this.allowSend()}
                onProgramContentEntrySend={this.handleProgramContentEntrySend}
              />
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  }

  handlePageChange(page) {
    this.props.updateProgramContentMeta({
      page: page,
    });
  }

  allowSend() {
    const {auth} = this.props;

    return isChatEnabled(auth);
  }

  handleProgramContentEntrySend(entry) {
    const { showNewMessageModal, sendMessage, sendMessageGroups } = this.props;

    showNewMessageModal({
      originProgramContentEntries: [{ value: entry.id, label: entry.title }],
      config: createModalConfig('LIBRARY_SEND_TIP'),
      modalCssClass: 'o-communication__modal o-communication__modal--large',
      onSendMessage: (params) => sendMessage(params),
      onSendMessageToGroups: (params) => sendMessageGroups(params),
    });
  }
}

const mapStateToProps = (state) => {
  return {
    programContentEntries: selectProgramContentLibraryEntries(state),
    meta: selectProgramContentLibraryMeta(state),
    auth: state.auth,
    isLoading: getLoaders(state, ['DASHBOARD_FILTER', 'PROGRAM_CONTENT_ENTRIES']),
  };
};

const mapDispatchToProps = {
  resetErrorMessage,
  fetchProgramContentEntries,
  updateProgramContentMeta,
  showNewMessageModal,
  sendMessage,
  sendMessageGroups,
};


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProgramContentLibraryPage);
